import { useLocation } from "react-router-dom";

export const useIsK8sLensDetailPage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const clusterId = params.get("cluster");

  return Boolean(clusterId);
};
